<template>
  <div>
    <el-form ref="formRef" :model="formData" :rules="formRules" :inline="true">
      <el-row>
        <el-col :span="12">
          <el-form-item label="救助医院" prop="hospitalId">
            <HospitalSelect v-model="formData.hospitalId" @change="hospitalChange" v-if="!readOnly" :disabled=" isHospitalRole">
            </HospitalSelect>
            <el-input  :value="formData.hospitalName?formData.hospitalName:'-'" disabled v-else size="small"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="病种" prop="diseasesIdList">
            <el-input v-if="readOnly" :value="formData.diseasesNameSet || '-'" disabled size="small" />
            <DiseaseCascader
              v-else
              v-model="formData.diseasesIdList"
              :hospitalId="formData.hospitalId"
              :multiple="true"
              :disabled="dataMode == 'reset' || readOnly"
              placeholder="点击选择病种或在此输入进行检索"
              @change="diseaseChange">
            </DiseaseCascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="单次/分期" prop="quotaType">
            <el-radio-group v-model="formData.quotaType" :disabled="disabledQuotaType || isAllowStages == 0 || dataMode == 'reset'" @change="quotaChange">
              <el-radio :label="0">单次</el-radio>
              <el-radio :label="1">分期</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="期数" style="position: relative"  prop="totalStages">
            <el-input v-if="isAngleDiseases || (!formData.totalStages && readOnly)" type="text" :disabled="true" value="-" size="small" />
            <el-input v-else type="text" :disabled="true" v-model="formData.totalStages" size="small" />
            <div style="width: 200px;height:20px;" v-if="!isAngleDiseases&&formData.quotaType==1&&!readOnly" class="error">
              <!-- <img src="/static/err-icon.png" alt=""> -->
              <span style="font-size: 12px;">如需修改期数，请联系项目人员！</span>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="当前期次" prop="curStages">
            <el-input v-if="readOnly" type="text" :disabled="true" v-model="formData.curStages" size="small" />
            <!-- <el-input v-else-if="isAngleDiseases || (!formData.curStages && readOnly)" type="text" :disabled="true" value="1" size="small" /> -->
            <el-input v-else type="text" :disabled="true" v-model="formData.curStages" size="small" />
          </el-form-item>
        </el-col>
        <!-- <el-col v-if="initialProject == 'AY1001'" :span="6">
          <el-form-item label="病种类型" prop="diseasesType">
            <DictionarySelect v-model="formData.diseasesType" :lazy="true"
              :disabled="readOnly" tableCode="DISEASES_TYPE" />
          </el-form-item>
        </el-col> -->
      </el-row>

      <div v-if="isAngleDiseases && formData.diseasesIdList && formData.diseasesIdList.length > 0">
        <ChapterHead :level="2">基础信息</ChapterHead>
        <el-row>
          <el-col :span="6">
            <el-form-item label="确诊日期" prop="diagnosisDate">
              <el-input type="text" v-if="readOnly" :disabled="true" :value="formData.diagnosisDate?parseTime(formData.diagnosisDate, '{y}-{m}-{d}'):'-'" size="small" />
              <el-date-picker
                v-model="formData.diagnosisDate"
                size="small"
                v-else
                type="date"
                format="yyyy-MM-dd"
                value-format="timestamp"
                :picker-options="pickerOptions"
                :disabled="readOnly"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否属于复发" prop="isRecur">
              <el-radio-group v-model="formData.isRecur" :disabled="readOnly">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="是否进过ICU" prop="isIcu">
              <el-radio-group v-model="formData.isIcu" :disabled="readOnly">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <ChapterHead :level="2">现阶段治疗情况</ChapterHead>
        <el-row>
          <el-col :span="12">
            <el-form-item label="当前治疗情况" prop="curHealStateList">
              <el-checkbox-group :disabled="readOnly" v-model="curHealStateList">
                <el-checkbox label="1">化疗</el-checkbox>
                <el-checkbox label="2">手术</el-checkbox>
                <el-checkbox label="3">移植</el-checkbox>
                <el-checkbox label="4">放疗</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="curHealStateList && curHealStateList.indexOf('3') > -1">
            <el-form-item label="是否入仓" prop="isStore">
              <el-radio-group v-model="formData.isStore" :disabled="readOnly">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6" v-if="curHealStateList && (curHealStateList.indexOf('1') > -1 || curHealStateList.indexOf('4') > -1)">
            <el-form-item label="总放化疗期数" prop="chemotheTotal">
              <NumberInput type="text" :disabled="readOnly" v-model="formData.chemotheTotal" size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="curHealStateList && (curHealStateList.indexOf('1') > -1 || curHealStateList.indexOf('4') > -1)">
            <el-form-item label="当前期数" prop="chemotheNum">
              <NumberInput type="text" :disabled="readOnly" v-model="formData.chemotheNum" size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="其他治疗情况" prop="otherHealState">
              <el-input v-if="readOnly && !formData.otherHealState" type="text" disabled value="-" size="small" />
              <el-input v-else type="text" :disabled="readOnly" v-model="formData.otherHealState" size="small" />
            </el-form-item>
          </el-col>
        </el-row>
        <ChapterHead :level="2">病历附件</ChapterHead>
        <el-row style="margin-bottom: 8px;">
          <el-form-item label="诊断证明" prop="attach.diagnoseEvidenceList">
            <FileUpload v-model="formData.attach.diagnoseEvidenceList" :disabled="readOnly"></FileUpload>
          </el-form-item>
        </el-row>
        <el-row style="margin-bottom: 8px;">
          <el-form-item label="骨穿报告/检查报告" prop="attach.checkReportList">
            <FileUpload v-model="formData.attach.checkReportList" :disabled="readOnly"></FileUpload>
          </el-form-item>
        </el-row>
        <!-- <el-row style="margin-bottom: 8px;">
          <el-form-item label="患儿病情信息表" prop="attach.illnessInfoList">
            <FileUpload v-model="formData.attach.illnessInfoList" :disabled="readOnly"></FileUpload>
          </el-form-item>
        </el-row> -->
        <el-row v-if="curHealStateList && curHealStateList.indexOf('3') > -1" style="margin-bottom: 8px;">
          <el-form-item label="配型报告/申请书病情信息页" prop="attach.transplantRequestList">
            <FileUpload v-model="formData.attach.transplantRequestList" :disabled="readOnly"></FileUpload>
          </el-form-item>
        </el-row>
        <!-- <el-row v-if="curHealStateList && curHealStateList.indexOf('3') > -1" style="margin-bottom: 8px;">
          <el-form-item label="配型报告" prop="attach.matchRequestList">
            <FileUpload v-model="formData.attach.matchRequestList" :disabled="readOnly"></FileUpload>
          </el-form-item>
        </el-row>
        <el-row v-if="curHealStateList && curHealStateList.indexOf('3') > -1" style="margin-bottom: 8px;">
          <el-form-item label="申请书病情信息表页" prop="attach.applicationRequestList">
            <FileUpload v-model="formData.attach.applicationRequestList" :disabled="readOnly"></FileUpload>
          </el-form-item>
        </el-row> -->
      </div>
      <!-- 童心/晨星 -->
      <div v-else>
        <ChapterHead v-if="formData.curStages > 1 || formData.reqMode == 1" :level="2">病历附件</ChapterHead>
        <el-form-item v-if="formData.curStages > 1 || formData.reqMode == 1" label="术前B超/诊断证明原件" prop="attach.attachList">
          <FileUpload v-model="formData.attach.attachList" :disabled="readOnly"></FileUpload>
        </el-form-item>
      </div>
    </el-form>
  </div>
</template>

<script>
import { getHelpRequestDataById, getHelpStagesDataByIdApi, getCaseDataByHelpId, getCaseAttachInfoSet } from "@/util/api.js";
import FileUpload from "@/components/business/FileUpload";
import ChapterHead from "@/components/business/ChapterHead";
import DiseaseCascader from "@/components/business/DiseaseCascader";
import HospitalSelect from "@/components/business/HospitalSelect";
import DictionarySelect from "@/components/business/DictionarySelect";
import NumberInput from "@/components/business/NumberInput";

export default {
  components: {
    FileUpload,
    ChapterHead,
    DiseaseCascader,
    HospitalSelect,
    DictionarySelect,
    NumberInput
  },
  props: {
    readOnly: {
      type: Boolean,
      default: true
    },
    dataMode: {
      type: String,
      default: 'add'
    },
    child: {
      type: Object,
      default () {
        return {}
      }
    },
    addAngleStages: {
      type: Boolean,
      default: false
    },
    belongProject: String,
    helpReqId: String,
    helpId: String
  },
  data () {
    let _this = this;
    let isHospitalRole = this.isHospital ? this.isHospital() : false;
    return {
      isHospitalRole: isHospitalRole,
      formData: {
        attach: {},
        quotaType: null
      },
      disabledQuotaType: this.readOnly,
      totalStagesTemp: null,
      quotaTypeTemp: null,
      curStagesTemp: null,
      proxyCaseInfo: {},
      isAllowStages:0,
      curHealStateList: [],
      initialProject: null,
      isBobyDiseases: false,
      isAngleDiseases: this.belongProject ? this.belongProject == 'AY1002' : false,
      formRules: {
        hospitalId: [{ required: true, message: "请选择救助医院", trigger: "change" }],
        diseasesIdList: [{ required: true, message: "请选择病种", trigger: "change" }],
        // diseasesType: [{ required: true, message: "请选择病种类型", trigger: "change" }],
        quotaType: [{ required: true, message: "请选择单次/分期", trigger: "change" }],
        // diagnosisDate: [{ required: true, message: "请选择确诊时间", trigger: "change" }],
        chemotheTotal: [{ required: true, message: "请输入总放化疗期数", trigger: "blur" }],
        chemotheNum: [{ required: true, message: "请输入当前放化疗期数", trigger: "blur" }],
        isRecur: [{ required: true, message: "请选择是否属于复发", trigger: "change" }],
        isIcu: [{ required: true, message: "请选择是否进入过ICU", trigger: "change" }],
        isStore: [{ required: true, message: "请选择是否入仓", trigger: "change" }],
        'attach.diagnoseEvidenceList': [{ required: true, message: "请上传诊断证明", trigger: "change" }],
        'attach.checkReportList': [{ required: true, message: "请上传骨穿报告/检查报告", trigger: "change" }],
        'attach.illnessInfoList': [{ required: true, message: "请上传患儿病情信息表", trigger: "change" }],
        'attach.transplantRequestList': [{ required: true, message: "请上传配型报告/申请书病情信息页", trigger: "change" }],
        'attach.matchRequestList': [{ required: true, message: "请上传配型报告", trigger: "change" }],
        'attach.applicationRequestList': [{ required: true, message: "请上传申请书病情信息表页", trigger: "change" }],
        'attach.attachList': [{ required: true, message: "请上传术前B超/诊断证明原件", trigger: "change" }],
      },
      pickerOptions: {
        disabledDate (time) {
          let birthday = new Date(_this.child.birthday);
          let startDate = birthday.setDate(birthday.getDate());
          return time.getTime() > Date.now() || time.getTime() < startDate;
        }
      },
    }
  },
  watch: {
    helpReqId: {
      immediate: true,
      handler (val) {
        if (val) {
          this.loadData()
        }
      }
    }
  },
  methods: {
    hospitalChange(id, obj){
      this.isAllowStages = obj.isAllowStages;
      if (this.formData.diseasesIdList && this.formData.diseasesIdList.length > 0) {
        this.formData.diseasesIdList = null;
        this.diseaseChange(null, false, false, null);
      }
      this.$emit('hospitalChange', obj);
      // if (this.isAllowStages == 0) {
      //   this.$set(this.formData, 'quotaType', 0);
      // }
    },
    loadData () {
      let request = null;
      if (this.helpId) {
        request = getHelpStagesDataByIdApi({helpId: this.helpId});
      } else {
        request = getHelpRequestDataById({helpReqId: this.helpReqId});
      }
      request.then(reqData => {
        if (reqData.msgCode == 200 && reqData.responseData) {
          let diseasesIdList = reqData.responseData.diseasesList && reqData.responseData.diseasesList.map(d => {
            return d.diseasesId;
          });
          let _this = this;
          this.getCaseData(this.helpId || reqData.responseData.helpId, reqData.responseData, function (caseInfo) {
            _this.proxyCaseInfo = caseInfo || {};
            let curHealState = _this.proxyCaseInfo.curHealState;
            if (curHealState) {
              _this.curHealStateList = curHealState.indexOf(',') > 0 ? curHealState.split(',') : [curHealState];
            }
            let initialProject = reqData.responseData.initialProject;
            _this.isAngleDiseases = initialProject == 'AY1002';
            _this.formData = {
              ..._this.proxyCaseInfo,
              hospitalId: reqData.responseData.hospitalId,
              hospitalName: reqData.responseData.hospitalName,
              quotaType: reqData.responseData.quotaType,
              totalStages: reqData.responseData.totalStages,
              curMaxStages: reqData.responseData.curMaxStages,
              //curStages: _this.addAngleStages ? reqData.responseData.curMaxStages : _this.proxyCaseInfo.curStages,
              curStages: _this.addAngleStages==false? reqData.responseData.curStages : _this.proxyCaseInfo.curStages,
              reqMode: reqData.responseData.reqMode,
              apprStatus: reqData.responseData.apprStatus,
              diseasesIdList: diseasesIdList || [],
              diseasesNameSet: reqData.responseData.diseasesNameSet,
              diseasesType: reqData.responseData.diseasesType,
              attach: {}
            };
            _this.isAllowStages = reqData.responseData.isAllowStages;
            _this.totalStagesTemp = reqData.responseData.totalStages;
            _this.quotaTypeTemp = reqData.responseData.quotaType;
            _this.curStagesTemp = reqData.responseData.curStages;
            // if (_this.formData.diseasesIdList && _this.formData.diseasesIdList.length > 0) {
            //   _this.diseaseChange(_this.formData.diseasesIdList, reqData.responseData.isWelfareBaby == 1, initialProject == 'AY1002', initialProject);
            // }
            let helpId = _this.helpId || (_this.proxyCaseInfo ? _this.proxyCaseInfo.helpId : null);
            if (helpId) {
              getCaseAttachInfoSet({
                helpId: helpId,
                attachTypes: initialProject == 'AY1002' ? '11,12,13,14,15,16' : '21'
              }).then(res => {
                if (res.msgCode == 200) {
                  _this.formData.attach = {};
                  if (initialProject == 'AY1002') {
                    // 诊断证明原件
                    _this.formData.attach.diagnoseEvidenceList = res.responseData['11'] ? res.responseData['11'].map(d => { return d.attachId; }) : [];
                    // 骨穿报告/检查报告
                    _this.formData.attach.checkReportList = res.responseData['12'] ? res.responseData['12'].map(d => { return d.attachId; }) : [];
                    // 患儿病情
                    _this.formData.attach.illnessInfoList = res.responseData['13'] ? res.responseData['13'].map(d => { return d.attachId; }) : [];
                    // 移植救助申请材料
                    _this.formData.attach.transplantRequestList = res.responseData['14'] ? res.responseData['14'].map(d => { return d.attachId; }) : [];
                    // 移植救助申请材料
                    _this.formData.attach.matchRequestList = res.responseData['15'] ? res.responseData['15'].map(d => { return d.attachId; }) : [];
                    // 移植救助申请材料
                    _this.formData.attach.applicationRequestList = res.responseData['16'] ? res.responseData['16'].map(d => { return d.attachId; }) : [];
                  } else {
                    // 术前B超/诊断证明原件
                    _this.formData.attach.attachList = res.responseData['21'] ? res.responseData['21'].map(d => { return d.attachId; }) : [];
                  }
                }
              });
            }
          });
        } else {
          this.$message.error(reqData.msg);
        }
      });
    },
    getCaseData (helpId, requestData, callback) {
      if (helpId) {
        getCaseDataByHelpId({ helpId: helpId }).then(res => {
          if (res.msgCode == 200) {
            callback(res.responseData);
          }
        });
      } else {
        callback(requestData.proxyCaseInfo);
      }
    },
    diseaseChange (val, isBoby, isAngle, initialProject) {
      if (val && val.length > 0 && initialProject) {
        this.isBobyDiseases = isBoby;
        this.isAngleDiseases = isAngle;
        this.initialProject = initialProject;
        this.formData.reqMode = this.dataMode == 'add' ? '2' : this.formData.reqMode;
        this.disabledQuotaType = this.readOnly || this.isAllowStages == 0 || initialProject != 'AY1001';
        if (this.disabledQuotaType) {
          this.$set(this.formData, 'quotaType', this.isAngleDiseases ? 1 : 0);
          this.quotaChange(this.formData.quotaType);
        }
      } else {
        this.$set(this.formData, 'quotaType', null);
        this.formData.totalStages = null;
        this.formData.curStages = null;
        this.isBobyDiseases = null;
        this.isAngleDiseases = null;
        this.initialProject = null;
      }

      this.$emit('diseaseChange', val, isBoby, isAngle, initialProject);
      return;
    },
    quotaChange (val) {
      if (!this.readOnly) {
        if (val == 1) {
          this.formData.totalStages = this.isAngleDiseases ? null : 3;
          this.formData.curStages = this.formData.curStages || 1;
        } else {
          this.formData.totalStages = 1;
          this.formData.curStages = 1;
        }
        this.$forceUpdate()
      }
    },
    attachChange () {
      this.$refs.formRef.validate();
    },
    validate (callback) {
      this.$refs.formRef.validate((valid) => {
        callback(valid)
      });
    },
    getFormData () {
      if (this.curHealStateList && this.curHealStateList.length > 0) {
        this.formData.curHealState = this.curHealStateList.join(',');
      }
      this.formData.diagnoseEvidenceList = this.setAttachList('diagnoseEvidenceList', '11');
      this.formData.checkReportList = this.setAttachList('checkReportList', '12');
      this.formData.illnessInfoList = this.setAttachList('illnessInfoList', '13');
      this.formData.transplantRequestList = this.setAttachList('transplantRequestList', '14');
      this.formData.matchRequestList = this.setAttachList('matchRequestList', '15');
      this.formData.applicationRequestList = this.setAttachList('applicationRequestList', '16');
      this.formData.attachList = this.setAttachList('attachList', '21');
      return this.formData;
    },
    setAttachList (key, fileType) {
      if (this.formData.attach[key] && this.formData.attach[key].length > 0) {
        return this.formData.attach[key].map(id => {
          return {
            fileType: fileType,
            attachId: id
          }
        });
      } else {
        return [];
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../common/form.scss';
.error{
  position: absolute;
  display: flex;
  font-size:  12px;
  color: #F56C6C;
  bottom: -12px;
  align-items: center;
  span{
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/child/view/ChildCase.vue